<template>
    <div class="cell-edit">
        <transition name="fade" mode="out-in">
            <div v-if="!edit" key="value" @dblclick="showEdit" class="cell-edit__value test-button-edit-location">
                <div v-if="!edit" key="value" @dblclick="showEdit" class="cell-edit__value test-button-edit-remark">
                    <span v-if="textVal.length !== 0">{{ textVal }}</span>
                    <span class="placeholder" v-else>{{ $t('dashboard.remark.double_click') }}<br/>{{ $t('dashboard.remark.to_add') }}</span>
                </div>
            </div>
            <div v-if="edit" key="value" class="cell-edit__value test-button-edit-location">
                <div class="cell-edit__input" key="edit">
                    <div class="remark-history-modal" v-click-outside="hideRemarkHistory">
                        <div class="remark-history-modal-header">
                            <span v-if="tentacle.name">{{ tentacle.name }}</span>
                            <div class="cell-edit__input" key="edit">
                                <input class="input" v-model="val" :id="`test-input-${tentacle.name.toLowerCase().replace(' ', '-')}`" />
                                <button class="cell-edit__input__save" @click="save">
                                    <BaseIcon icon="check" />
                                </button>
                                <button class="cell-edit__input__cancel" @click="cancel">
                                    <BaseIcon icon="cancel" />
                                </button>
                            </div>
                            <div class="clear-remark" @click="clearRemark">
                                clear remark
                            </div>
                        </div>
                        <div class="remark-history-modal-gradient"></div>
                        <div class="remark-history-modal-body">
                            <Timeline
                                    :timeline-items="this.history"
                                    :message-when-no-items="this.$t('dashboard.remark.history')"
                                    :unique-year="true"
                                    :unique-timeline="true"
                                    :color-dots="'#b2de4d'"
                            />
                        </div>
                        <div class="remark-history-modal-gradient-down"></div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import Timeline from 'timeline-vuejs';
import {mapGetters} from "vuex";

export default {
  name: 'BaseInputCell',
  components: {
    Timeline,
  },
  props: {
    value: {
      type: String | Number,
      default: '',
    },
    tentacle: {
      type: Object,
    },

  },
  data() {
    return {
      val: this.value,
      edit: false,
      showRemarkHistory: false,
    };
  },
  computed: {
    textVal() {
      return (this.val.length > 35) ? `${this.val.substring(0, 32)}..` : this.val;
    },
    history() {
      return this.tentacle.remarkHistory.map(function(history) {
        const time = new Date(history.createdAt.date);
        return {
          from: new Date(history.createdAt.date),
          title: ('<div class="time">' + time.toLocaleTimeString() + '</div>' + history.user),
          description: history.remark,
          showDayAndMonth: true,
          color: '#b2de4d',
        };
      });
    },
  },
  watch: {
    value() {
      this.val = this.value;
    },
  },
  methods: {
    save() {
      this.edit = false;
      this.$emit('onChange', this.val);
    },
    cancel() {
      this.edit = false;
      this.val = this.value;
    },
    showEdit() {
      this.edit = true;
    },
    toggleRemarkHistory() {
      this.showRemarkHistory = !this.showRemarkHistory;
    },
    hideRemarkHistory() {
      this.showRemarkHistory = false;
    },
    clearRemark() {
      const remarkInputId = 'test-input-' + this.tentacle.name.toLowerCase().replace(' ', '-');
      document.getElementById(remarkInputId).value = "";
      document.getElementById(remarkInputId).focus();
    },
  },
};
</script>

<style lang="scss">

.timeline {
  .year {
    font-size: 0.7em !important;
  }

  .date-item {
    font-size: 0.7em !important;
  }

  .title-item {
    font-size: 0.8em !important;
  }

  .description-item {
    color: #000 !important;
  }
}

</style>

<style lang="scss" scoped>
.historyLink {
  cursor: pointer;
}
.cell-edit {
  align-self: center;
  height: 4.5rem;
  display: flex;
  align-items: stretch;
  width: 90%;
  margin-left: -0.5rem;
  min-width: 10em;

  &__value {
    padding: 0 0.5rem;
    width: 100%;
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: all 0.4s;

    &:hover {
      background-color: $bg;
    }
    .placeholder {
      color:rgba(172,180,197,0.35);
    }
  }

  &__input {
    position: relative;

    .remark-history {
      position: absolute;
      top: 45px;
      padding: 0.3rem;
      overflow: auto;
      background-color: #ffffffee;
      z-index: 2;
    }

    .remark-history-modal {
      z-index: 99;
      top: calc(50vh - 20rem);
      left: calc(40vw - 23rem);
      position: fixed;
      display: block;
      padding: 1rem 1rem;
      width: 45rem;
      max-height: 40rem;
      background-color: white;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(37, 44, 97, 0.15),
      0 0.2rem 0.4rem 0 rgba(93, 100, 148, 0.2);
      border-radius: 0.5rem;
      @media only screen and (max-width: 991px) {
        /* width: 100%; */
        top: 1rem;
        left: 0;
      }

      .remark-history-modal-header > div{
         margin-top: 5px;
      }
      .remark-history-modal-header > span{
         padding-left: 10px;
      }
      .clear-remark {
         padding-left: 10px;
      }
      .remark-history-modal-body {
        height: 30rem;
        overflow: auto;
        position: relative;
        padding-top: 3rem;
        padding-bottom: 3rem;
      }
      .remark-history-modal-gradient {
        width: 100%;
        height: 60px;
        position: absolute;
        top: 9.5rem;
        left: 0;
        z-index: 1;
        background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
      }
      .remark-history-modal-gradient-down {
        width: 100%;
        height: 60px;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
      }
    }

    .input {
      padding-right: 3rem;
    }

    button {
      border: none;
      color: white;
      font-weight: 600;
      font-size: 1rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      right: 0;
      height: 50%;
      width: 3rem;
      position: absolute;
    }

    &__save {
      top: 0;
      background-color: $company-color;
      border-radius: 0 0.5rem 0 0;

      &:hover {
        background-color: darken($company-color, 10%);
      }

      .icon {
        fill: white;
        width: 1.2rem;
        height: 1.2rem;
      }
    }

    &__cancel {
      bottom: 0;
      background-color: #bec4d3;
      border-radius: 0 0 0.5rem 0;

      &:hover {
        background-color: darken(#bec4d3, 10%);
      }

      .icon {
        fill: white;
        width: 1rem;
        height: 1rem;
      }
    }
  }
}
</style>
